import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/intercepter/axiosConfig';

const ActeHypotheque = () => {
  const navigate = useNavigate();
  const { id_hypotheque } = useParams();

  const [date_depot, setDateDepot] = useState('');
  const [num_depot, setNumDepot] = useState('');

  const [message, setMessage] = useState("")
  const [messageType, setMessageType] = useState("")
  const [isSubmitting, setIsSubmiting] = useState("")


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmiting(true);

    // console.log("Numéro de dépôt :", num_depot);
    // console.log("Date de dépôt :", date_depot);

     try{
    const response = await api.post("/auth/InitierActeDeHypotheque",{
        num_depot: num_depot,
        date_depot: date_depot,
        id_hypotheque: id_hypotheque
    })

    if(response.data.status){

      setMessage(response.data.message);
      setMessageType("success");

      setTimeout(()=>
        navigate(`/hypotheque/show/${id_hypotheque}`),
        1000)
        
    }
    else{
        setMessage(response.data.message)
        setMessageType("error")
    }
  }catch(error){
            if (error.response) {
                const data = error.response.data;
                setMessage(data.message || "Erreur réseau.");
                setMessageType("error");
            } else {
              setMessage("Erreur réseau.");
              setMessageType("error");
            }
        }finally{
          setIsSubmiting(false);
        }
      }

  const retour = () => {
    navigate(-1); // Retour à la page précédente
  };

  return (
    <div className='main-container'>
      <div className='container'>

        {message && (
                <div className={`mt-3 alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}>
                  {message}
                </div>
              )}
              

        <div className='row'>
          <div className='col-12 col-md-6 offset-md-3'>
            <div className='card mt-4'>
              <div className='card-header d-flex justify-content-between align-items-center'>
                <span>Initier infos d'Acte d'Hypothèque</span>
                <button onClick={retour} className='btn btn-secondary btn-sm'>
                  Retour
                </button>
              </div>

              <div className='card-body'>
                <form onSubmit={handleSubmit}>
                  <div className='mb-3'>
                    <label htmlFor='date_depot' className='form-label'>
                      Date de dépôt
                    </label>
                    <input
                      type='date'
                      className='form-control form-control-sm'
                      id='date_depot'
                      value={date_depot}
                      onChange={(e) => setDateDepot(e.target.value)}
                      required
                    />
                  </div>

                  <div className='mb-3'>
                    <label htmlFor='num_depot' className='form-label'>
                      Numéro de dépôt
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      id='num_depot'
                      placeholder='Entrez le numéro de dépôt'
                      value={num_depot}
                      onChange={(e) => setNumDepot(e.target.value)}
                      required
                    />
                  </div>

                  <button type='submit' className='btn btn-success btn-sm w-100'  disabled={isSubmitting}>
                    
                     {isSubmitting ? 'En cours...' : "Initier"}
                    
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActeHypotheque;
